import { useEffect, useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useProject } from "./context/ProjectContext";
import { useDraftByIdQuery } from "../../workspace/hooks/useDraftByIdQuery";
import { useSiteByIdQuery } from "../../workspace/hooks/useSIteByQuery";
import { usePageBuilder } from "../core/hooks";
import { useLoadEditorContent } from "../core/editor/boostrap/initialize.editor";

export function ProjectBootstrap() {
    const { draftId } = useParams<{ draftId: string }>();
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");

    const isDraft = type === "draft";
    const isSite = type === "publish" || !type;

    const { initializeProject } = useProject();
    const { editorRef } = usePageBuilder();

    const {
        data: draft,
        isLoading: draftLoading,
        isError: draftIsError,
    } = useDraftByIdQuery(draftId!, { enabled: !!draftId && isDraft });

    const {
        data: site,
        isLoading: siteLoading,
        isError: siteIsError,
    } = useSiteByIdQuery(draftId!, { enabled: !!draftId && isSite });

    // 1) Normaliza un “payload” único para el editor
    const editorPayload = useMemo(() => {
        if (!draftId) return null;

        if (isDraft) {
            if (draftLoading || draftIsError || !draft) return null;
            return {
                html: draft.content?.html ?? "",
                css: draft.content?.css ?? "",
            };
        }

        if (isSite) {
            if (siteLoading || siteIsError || !site) return null;
            return {
                html: site.latestVersion?.content?.html ?? "",
                css: site.latestVersion?.content?.css ?? "",
            };
        }

        return null;
    }, [
        draftId,
        isDraft,
        isSite,
        draft,
        draftLoading,
        draftIsError,
        site,
        siteLoading,
        siteIsError,
    ]);


    useLoadEditorContent(editorRef.current, editorPayload);

    // 3) Inicializa tu contexto de proyecto (solo datos del proyecto)
    useEffect(() => {
        if (!draftId) return;

        if (isDraft) {
            if (draftLoading || draftIsError || !draft) return;

            initializeProject({
                projectName: draft.projectName,
                activeTemplateId: draft.templateId,
                // slugName: draft.slug ?? "",
            });

            return;
        }

        if (isSite) {
            if (siteLoading || siteIsError || !site) return;

            initializeProject({
                activeTemplateId: site.templateId,
                projectName: site.projectName,
                slugName: site.slug,
            }
            );
        }
    }, [
        draftId,
        isDraft,
        isSite,
        draft,
        draftLoading,
        draftIsError,
        site,
        siteLoading,
        siteIsError,
        initializeProject,
    ]);

    return null;
}
